import actions from './actions';
import authActions from '../auth/actions';

const initState = {
  paymentCount: null,
  isLoadingDashboard: false,
  hasError: false,
  isRaffleEntry: false,
  raffleEntry: null,
  isSuccessEntry: null,
  isStartRaffle: false,
  winnerRaffle: null,
  isGetWinner: false,
  winner: null,
  isErrorUserSettings: false,
  isGetUserSettings: false,
  userSettings: null,
  isUpdateVat: false,
  fetchingPaymentCounts: false,
  fetchedPaymentCounts: null,
  fetchingSuccessRate: false,
  fetchedSuccessRate: null,
  successRateFilter: null,
  successRatePagination: null,
  accountNotificationLoading: false,
  accountNotificationLoadMore: false,
  accountNotificationData: null,
  accountNotificationIsError: false,
  accountNotificationPagination: null,
  unreadCount: 0,
  readNotificationLoading: false,

  accountSystemLogsLoading: false,
  accountSystemLogsLoadMore: false,
  accountSystemLogsData: null,
  accountSystemLogsIsError: false,
  accountSystemLogsPagination: null,
  systemLogsUnreadCount: 0,

  approvalRequestLoading: false,
  approvalRequestLoadMore: false,
  approvalRequestData: null,
  approvalRequestIsError: false,
  approvalRequestPagination: null,
  approvalRequestFilter: null,
  errorMessage: null,

  notificationData: null
};

export default function dbRed(state = initState, action) {
  switch (action.type) {
    case actions.LOADED_DASHBOARD_DATA:
      return {
        ...state,
        paymentCount: action.payload
      };
    case actions.LOADING_DASHBOARD_DATA:
      return {
        ...state,
        isLoadingDashboard: action.payload
      };
    case actions.LOAD_DASHBOARD_ERROR:
      return {
        ...state,
        isLoadingDashboard: false
      };
    case actions.RESET_DASHBOARD_DATA:
      return {
        ...state,
        isLoadingDashboard: false,
        paymentCount: null
      };
    case actions.RAFFLE_ENTRY:
      return {
        ...state,
        raffleEntry: action.payload,
        isRaffleEntry: false,
        isSuccessEntry: action.success
      };
    case actions.SENDING_RAFFLE_ENTRY:
      return {
        ...state,
        isRaffleEntry: action.payload
      };
    case actions.SENDING_FAILED_RAFFLE_ENTRY:
      return {
        ...state,
        isRaffleEntry: false
      };
    case actions.STARTING_RAFFLE:
      return {
        ...state,
        isStartRaffle: action.payload
      };
    case actions.DONE_RAFFLE:
      return {
        ...state,
        winnerRaffle: action.payload,
        isStartRaffle: false
      };
    case actions.GETTING_WINNERS:
      return {
        ...state,
        isGetWinner: action.payload
      };
    case actions.GOT_WINNERS:
      return {
        ...state,
        winner: action.payload
      };
    case actions.GOT_USER_SETTINGS:
      return {
        ...state,
        userSettings: action.payload,
        isGetUserSettings: false
      };
    case actions.GETTING_USER_SETTINGS:
      return {
        ...state,
        isGetUserSettings: action.payload
      };
    case actions.UPDATING_VAT_AGGREE:
      return {
        ...state,
        isUpdateVat: action.payload
      };
    case actions.ERROR_USER_SETTINGS:
      return {
        ...state,
        isErrorUserSettings: action.payload
      };
    case actions.FETCHED_PAYMENT_COUNT:
      return {
        ...state,
        fetchingPaymentCounts: false,
        fetchedPaymentCounts: action.payload,
        hasError: false
      };

    case actions.FETCHING_PAYMENT_COUNT_FAILED:
      return {
        ...state,
        fetchingPaymentCounts: false,
        fetchedPaymentCounts: action.payload,
        hasError: true
      };
    case actions.RESET_FETCHED_PAYMENT_COUNT:
      return {
        ...state,
        fetchingPaymentCounts: false,
        fetchedPaymentCounts: null,
        hasError: false
      };
    case actions.FETCHING_PAYMENT_COUNT:
      return {
        ...state,
        fetchingPaymentCounts: true
      };

    case actions.FETCHING_SUCCESS_RATE:
      return {
        ...state,
        fetchingSuccessRate: true,
        successRateFilter: action.filter
      };
    case actions.FETCH_SUCCESS_RATE_SUCCESS:
      return {
        ...state,
        fetchingSuccessRate: false,
        fetchedSuccessRate: action.payload,
        successRatePagination: action.pagination,
        hasError: false
      };

    case actions.FETCH_SUCCESS_RATE_FAILED:
      return {
        ...state,
        fetchingSuccessRate: false,
        fetchedSuccessRate: action.payload,
        successRatePagination: null,
        hasError: true
      };

    case actions.FETCHING_ACCOUNT_NOTIFICATION:
      return {
        ...state,
        accountNotificationLoading: action.loading
      };

    case actions.FETCH_ACCOUNT_NOTIFICATION_SUCCESS:
      return {
        ...state,
        accountNotificationLoading: action.loading,
        accountNotificationData: action.result,
        accountNotificationIsError: false,
        accountNotificationPagination: action.pagination,
        accountNotificationLoadMore: false,
        unreadCount: action.unreadCount
      };

    case actions.LOADING_MORE_ACCOUNT_NOTIFICATION:
      return {
        ...state,
        accountNotificationLoadMore: true
      };

    case actions.FETCH_ACCOUNT_NOTIFICATION_FAILED:
      return {
        ...state,
        accountNotificationLoading: action.loading,
        accountNotificationIsError: true,
        accountNotificationLoadMore: false,
        accountNotificationData: action.payload
      };
    case actions.RESET_ACCOUNT_NOTIFICATION:
      return {
        ...state,
        accountNotificationLoading: false,
        accountNotificationIsError: false,
        accountNotificationLoadMore: false,
        accountNotificationData: action.payload
      };

    case actions.PUSH_ACCOUNT_NOTIFICATION:
      return {
        ...state,
        accountNotificationLoading: false,
        accountNotificationIsError: false,
        accountNotificationLoadMore: false,
        accountNotificationData: action.payload,
        unreadCount: action.unreadCount
      };

    case actions.READING_ACCOUNT_NOTIFICATION:
      return {
        ...state,
        readNotificationLoading: action.loading
      };

    case actions.READ_ACCOUNT_NOTIFICATION_SUCCESS:
      return {
        ...state,
        readNotificationLoading: action.loading,
        accountNotificationData: action.payload,
        unreadCount: action.unreadCount
      };

    case actions.READ_ACCOUNT_NOTIFICATION_FAILED:
      return {
        ...state,
        readNotificationLoading: action.loading
      };

    case actions.FETCHING_ACCOUNT_SYSTEM_LOGS:
      return {
        ...state,
        accountSystemLogsLoading: action.loading
      };

    case actions.FETCH_ACCOUNT_SYSTEM_LOGS_SUCCESS:
      return {
        ...state,
        accountSystemLogsLoading: action.loading,
        accountSystemLogsData: action.result,
        accountSystemLogsIsError: false,
        accountSystemLogsPagination: action.pagination,
        accountSystemLogsLoadMore: false,
        systemLogsUnreadCount: action.unreadCount
      };

    case actions.LOADING_MORE_ACCOUNT_SYSTEM_LOGS:
      return {
        ...state,
        accountSystemLogsLoadMore: true
      };

    case actions.FETCH_ACCOUNT_SYSTEM_LOGS_FAILED:
      return {
        ...state,
        accountSystemLogsLoading: action.loading,
        accountSystemLogsIsError: true,
        accountSystemLogsLoadMore: false,
        accountSystemLogsData: action.payload
      };
    case actions.RESET_ACCOUNT_SYSTEM_LOGS:
      return {
        ...state,
        accountSystemLogsLoadMore: false,
        accountSystemLogsIsError: false,
        accountSystemLogsLoading: false,
        accountSystemLogsData: action.payload
      };

    case actions.PUSH_ACCOUNT_SYSTEM_LOGS:
      return {
        ...state,
        accountSystemLogsLoading: false,
        accountSystemLogsIsError: false,
        accountSystemLogsLoadMore: false,
        accountSystemLogsData: action.payload,
        systemLogsUnreadCount: action.unreadCount
      };

    case actions.READING_ACCOUNT_SYSTEM_LOGS:
      return {
        ...state,
        readNotificationLoading: action.loading
      };

    case actions.READ_ACCOUNT_SYSTEM_LOGS_SUCCESS:
      return {
        ...state,
        readNotificationLoading: action.loading,
        accountSystemLogsData: action.payload,
        systemLogsUnreadCount: action.unreadCount
      };

    case actions.READ_ACCOUNT_SYSTEM_LOGS_FAILED:
      return {
        ...state,
        readNotificationLoading: action.loading
      };

    case actions.FETCHING_APPROVAL_REQUESTS:
      return {
        ...state,
        approvalRequestLoading: action.loading
      };

    case actions.FETCH_APPROVAL_REQUESTS_SUCCESS:
      return {
        ...state,
        approvalRequestLoading: action.loading,
        approvalRequestData: action.result,
        approvalRequestIsError: false,
        approvalRequestPagination: action.pagination,
        approvalRequestLoadMore: false,
        approvalRequestFilter: action.filter
      };

    case actions.LOADING_MORE_APPROVAL_REQUESTS:
      return {
        ...state,
        approvalRequestLoadMore: true
      };

    case actions.FETCH_APPROVAL_REQUESTS_FAILED:
      return {
        ...state,
        approvalRequestLoading: action.loading,
        approvalRequestIsError: true,
        approvalRequestLoadMore: false,
        approvalRequestData: action.payload,
        approvalRequestFilter: null
      };
    case actions.RESET_APPROVAL_REQUESTS:
      return {
        ...state,
        approvalRequestLoadMore: false,
        approvalRequestIsError: false,
        approvalRequestLoading: false,
        approvalRequestData: action.payload,
        approvalRequestFilter: null
      };

    case actions.UPDATING_APPROVAL_REQUEST_STATUS:
      return {
        ...state,
        approvalRequestLoading: action.loading
      };

    case actions.UPDATE_APPROVAL_REQUEST_STATUS_SUCCESS:
      return {
        ...state,
        approvalRequestLoading: action.loading,
        approvalRequestIsError: false,
        errorMessage: action.message
      };

    case actions.UPDATE_APPROVAL_REQUEST_STATUS_FAILED:
      return {
        ...state,
        approvalRequestLoading: action.loading,
        approvalRequestIsError: true,
        errorMessage: action.message
      };

    case actions.SET_NOTIFICATION_DATA:
      return {
        ...state,
        notificationData: action.payload
      };

    case authActions.LOGOUT:
      // reset all redux param value
      return initState;
    default:
      return state;
  }
}
